import {getScoreKeyNameFromScorerRef} from '../../CompareEvaluationsPage/ecpUtil';
import {ScorerRefMap, ScoreTree} from './types';

export const formatScoreValue = (value: number | boolean): string => {
  if (typeof value === 'boolean') {
    return value ? '✓' : '✗';
  }

  if (Number.isInteger(value)) {
    return value.toString();
  }

  return value.toFixed(3);
};

export const buildScoreTree = (output: Record<string, unknown>): ScoreTree => {
  const tree: ScoreTree = {};

  Object.entries(output).forEach(([key, value]) => {
    if (key.startsWith('_') || key === 'model_latency') return;
    // Allow summary objects (NumericSummary, BooleanSummary) and nested trees
    tree[key] = value as number | boolean | ScoreTree;
  });

  return tree;
};

export const filterScoreTree = (
  scoreTree: ScoreTree,
  filterText: string
): ScoreTree => {
  if (!filterText) {
    return scoreTree;
  }

  try {
    const regex = new RegExp(filterText, 'i');
    const filtered: ScoreTree = {};

    const filterTree = (obj: unknown, currentPath: string): unknown => {
      if (typeof obj === 'number' || typeof obj === 'boolean') {
        return regex.test(currentPath) ? obj : null;
      }

      if (typeof obj === 'object' && obj !== null && !Array.isArray(obj)) {
        const result: ScoreTree = {};
        let hasMatches = false;

        Object.entries(obj).forEach(([key, val]) => {
          const newPath = currentPath ? `${currentPath}.${key}` : key;
          const filteredVal = filterTree(val, newPath);
          if (filteredVal !== null) {
            result[key] = filteredVal as number | boolean | ScoreTree;
            hasMatches = true;
          }
        });

        return hasMatches ? result : null;
      }

      return null;
    };

    Object.entries(scoreTree).forEach(([key, value]) => {
      const filteredVal = filterTree(value, key);
      if (filteredVal !== null) {
        filtered[key] = filteredVal as number | boolean | ScoreTree;
      }
    });

    return filtered;
  } catch {
    return scoreTree;
  }
};

export const buildScorerRefMap = (scorers: string[]): ScorerRefMap => {
  const map: ScorerRefMap = {};

  scorers.forEach((scorerRef: string) => {
    const scorerName = getScoreKeyNameFromScorerRef(scorerRef);
    if (scorerName) {
      map[scorerName] = scorerRef;
    }
  });

  return map;
};
